var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertIlmor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#CE0E2D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6434 29.7266C36.3465 30.9766 35.4481 32.5 34.0028 32.5H15.2918C13.8465 32.5 12.9481 30.9375 13.6512 29.7266L23.0262 13.4375C23.7293 12.1875 25.5653 12.2266 26.2684 13.4375L35.6434 29.7266ZM24.6668 26.3281C23.6512 26.3281 22.87 27.1484 22.87 28.125C22.87 29.1406 23.6512 29.9219 24.6668 29.9219C25.6434 29.9219 26.4637 29.1406 26.4637 28.125C26.4637 27.1484 25.6434 26.3281 24.6668 26.3281ZM22.9481 19.8828L23.2215 25.1953C23.2606 25.4688 23.4559 25.625 23.6903 25.625H25.6043C25.8387 25.625 26.034 25.4688 26.0731 25.1953L26.3465 19.8828C26.3856 19.6094 26.1512 19.375 25.8778 19.375H23.4168C23.1434 19.375 22.909 19.6094 22.9481 19.8828Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIlmor);
export default __webpack_public_path__ + "static/media/alertIlmor.52c9995add672eca1ac5004eb85c1ebd.svg";
export { ForwardRef as ReactComponent };